import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import {
  AiEntityType,
  AiTokensApiService,
} from "../../services/ai-tokens-api.service";
import { AiQuota } from "../../models/ai-quota.model";
import { AiQuotaFormDialogComponent } from "../ai-quota-form-dialog/ai-quota-form-dialog.component";

@Component({
  selector: "app-ai-entity-tokens",
  templateUrl: "./ai-entity-tokens.component.html",
  styleUrls: ["./ai-entity-tokens.component.scss"],
})
export class AiEntityTokensComponent implements OnChanges {
  @Input() entityType!: AiEntityType;
  @Input() entityId!: string;

  quotas: AiQuota[] = [];
  loading = false;

  constructor(private api: AiTokensApiService, private dialog: MatDialog) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      (changes["entityType"] || changes["entityId"]) &&
      this.entityType &&
      this.entityId
    ) {
      this.refresh();
    }
  }

  refresh(): void {
    this.loading = true;
    this.api.listQuotas(this.entityType, this.entityId).subscribe({
      next: (quotas) => {
        this.quotas = quotas;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  openCreate(): void {
    const ref = this.dialog.open(AiQuotaFormDialogComponent, {
      width: "450px",
      data: {
        mode: "create",
        entityType: this.entityType,
        entityId: this.entityId,
      },
    });
    ref.afterClosed().subscribe((ok) => {
      if (ok) this.refresh();
    });
  }

  openEdit(quota: AiQuota): void {
    const ref = this.dialog.open(AiQuotaFormDialogComponent, {
      width: "450px",
      data: {
        mode: "edit",
        entityType: this.entityType,
        entityId: this.entityId,
        quota,
      },
    });
    ref.afterClosed().subscribe((ok) => {
      if (ok) this.refresh();
    });
  }

  centsToDollars(c: number | null | undefined): string {
    if (c == null) return "—";
    return "$" + (c / 100).toFixed(2);
  }
}
